import {createSearchParams, useNavigate} from "react-router-dom";
import {useCallback} from "react";
import {urls} from "../../../../../routes/urls";
import NiceModal from "@ebay/nice-modal-react";
import ContactUsDialog from "../../../../../pages/contact-us/ContactUsDialog";
import {useUserMetaData, useUtils} from "../../../../../contexts";
import ContactMethodsDialog from "../../../../../pages/account/user-contact-details/contact-methods/ContactMethods";
import {useConsumerMenu} from "../../context/MenuContext";

export const useSupportActions = () => {
  const {clearCredentials} = useUtils();
  const {userId} = useUserMetaData();
  const {trackAndCloseMenu} = useConsumerMenu();
  const navigate = useNavigate();

  const shouldDisplaySupportOptions = Boolean(userId);

  const onLogout = useCallback(() => {
    trackAndCloseMenu("logout");
    clearCredentials();
    const targetUrl = userId
      ? {
          pathname: urls.login.url,
          search: createSearchParams({id: userId}).toString(),
        }
      : "/";
    navigate(targetUrl);
  }, [trackAndCloseMenu, clearCredentials, userId, navigate]);

  const onSupportClick = useCallback(async () => {
    trackAndCloseMenu("get_support");
    await NiceModal.show(ContactUsDialog, {});
  }, [trackAndCloseMenu]);

  const onManageContactClick = useCallback(async () => {
    trackAndCloseMenu("manage_contact");
    await NiceModal.show(ContactMethodsDialog, {});
  }, [trackAndCloseMenu]);

  return {onLogout, onSupportClick, onManageContactClick, shouldDisplaySupportOptions};
};
